import { SVGAttributes } from 'react'

const SortIcon = (props: SVGAttributes<SVGElement>) => (
    <svg width="18" height="16" viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg" {...props}>
        <defs>
            <linearGradient x1="0%" y1="10%" x2="0%" y2="90%" id="sort">
                <stop id="gradient-stop-1" offset="0%" stopColor="var(--stop-color-1)" />
                <stop id="gradient-stop-2" offset="100%" stopColor="var(--stop-color-2)" />
            </linearGradient>
        </defs>
        <path
            d="M26.185 12.728c.37-.21.826-.21 1.196 0 .373.212.603.605.603 1.03l-.002 8.662 1.593-1.512c.158-.151.354-.255.572-.303l.133-.022.148-.007c.317.005.619.135.84.36a1.181 1.181 0 0 1-.029 1.685l-3.66 3.478-.104.082-.054.036-.143.076-.053.023-.069.023-.139.038c-.155.03-.31.03-.475-.002l-.144-.04-.117-.045-.18-.102-.126-.098-3.643-3.464a1.182 1.182 0 0 1-.045-1.699c.224-.229.531-.359.852-.36.32-.004.63.12.852.34l1.59 1.512.001-8.66c0-.33.138-.641.381-.867l.11-.092.112-.072Zm-6.676-1.127.19.018.064.013.167.052.053.022.103.054.078.046.046.035.11.09 3.624 3.448a1.182 1.182 0 0 1 .03 1.685 1.207 1.207 0 0 1-1.694.029l-1.592-1.514.001 8.662c0 .33-.138.641-.38.867l-.111.092-.112.072c-.37.21-.825.21-1.196 0a1.186 1.186 0 0 1-.602-1.03l-.002-8.664-1.585 1.51a1.2 1.2 0 0 1-.591.318l-.138.022-.128.005a1.207 1.207 0 0 1-.85-.36 1.18 1.18 0 0 1 .038-1.694l3.632-3.454.123-.1.047-.033.151-.08.072-.031.192-.056.028-.006.185-.018h.047Z"
            transform="translate(-14 -11)"
            fill="url(#sort)"
        />
    </svg>
)

export default SortIcon
